import React, { useState } from "react";
import { MdOutlineMenu } from "react-icons/md";
import { MdOutlineMenuOpen } from "react-icons/md";
import { useSidebar } from "../sidebar/sidebar.context";
import logo from "../../assets/img/hds-edit-2.png";
import { routes } from "../../App";
import { ClickHandleNavigate } from "../page-nav-support.function";
import { BiSearch } from "react-icons/bi";

function Header() {
  const { toggleSidebar, setSidebarOpen } = useSidebar();
  const { isSidebarOpen } = useSidebar();
  const { onClickHandleNavigate } = ClickHandleNavigate();

  const onNavigate = (url, head) => {
    onClickHandleNavigate(url, head);
    setSidebarOpen(false);
    setSearchStr("");
  };

  const [searchStr, setSearchStr] = useState("");
  const [resRoute, setResRoute] = useState([]);

  const routesList = routes.map((el) => ({
    path: el.path,
    head: el.title.includes(" - ") ? el.title.split(" - ")[0] : el.title,
    title: el.title.includes(" - ") ? el.title.split(" - ")[1] : el.title,
  }));

  const searchStrChg = (str) => {
    setSearchStr(str);
    let resArr = [];
    resArr = routesList
      .filter((el) =>
        el.title.toLocaleLowerCase().includes(str.toLocaleLowerCase())
      )
      .filter((e) => e.head !== "Page Not Found");
    resArr.length > 0
      ? setResRoute(resArr)
      : setResRoute([{ title: "Not Found", path: "/" }]);
  };

  return (
    <div className="sticky right-0 top-0 left-0 flex justify-between items-center px-5 bg-white border border-ys-pewter-500 shadow-sm border-x-0 border-t-0 h-[72px] z-50">
      <span
        onClick={toggleSidebar}
        className="md:block cursor-pointer lgmin:hidden absolute text-xl text-primary-500"
      >
        {isSidebarOpen ? <MdOutlineMenuOpen /> : <MdOutlineMenu />}
      </span>
      <span className="md:ml-7 font-ibm font-semibold text-primary-500 opacity-90 cursor-default text-lg flex items-center">
        <img src={logo} className="w-[70px]" alt="" />
        Hatiuron
      </span>
      <div className="relative">
        {searchStr && (
          <BiSearch className="absolute right-0.5 top-1 text-neutral-500" />
        )}
        <input
          type="text"
          onChange={(e) => searchStrChg(e.target.value)}
          value={searchStr}
          className={`text-right px-2 pl-1 ${
            searchStr ? "pr-[22px]" : "pr-1"
          } w-52 sm:w-36 hover:placeholder:text-neutral-500 rounded-md outline-none focus:outline focus:outline-secondary-500 text-neutral-700`}
          placeholder="Search"
        />
        {searchStr && (
          <div className="w-full flex flex-col max-h-32 overflow-auto bg-white rounded-md border border-neutral-300 absolute mt-1.5">
            {resRoute.map((route, i) => (
              <span
                key={i}
                onClick={() => onNavigate(route.path, route.head)}
                className="py-2 px-2.5 font-semibold font-jakarta cursor-pointer hover:bg-neutral-200 text-neutral-500 hover:text-neutral-800"
              >
                {route.title}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
